









































































































































































































































import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
import { debounce } from 'debounce';
import { Action, Mutation } from 'vuex-class';
import { FilteredResultRequest } from '@/interfaces/FilteredResultRequest';
import { FilterData } from '@/interfaces/FilterData';
import { eventBus, eventBusEvents } from '@/helpers/eventBusHelper';
import {countWords} from '@/helpers/wordCountHelper';
import {SearchConstants} from '@/enums/SearchConstants';

@Component({
    name: 'AppSearchFilterSidebar',
})
export default class AppSearchFilterSidebar extends Vue {

    @Prop({default: 'search'}) protected sidebarMode!: string;
    @Prop({required: true}) protected isLoading!: string;
    @Prop({required: true}) protected numberOfReports!: number;

    @Action('search/filterSearchResults')
    protected filterSearchResults!: (filterObject: FilterData) => Promise<unknown>;
    @Action('user/filterShoppingListRecords')
    protected filterShoppingListRecords!: (filterObject: FilterData) => Promise<unknown>;
    @Action('user/getShoppingListRecords')
    protected getShoppingListRecords!: (filterObject: FilteredResultRequest) => void;
    @Action('search/narrowSearchByKeyword') protected narrowSearchByKeyword!:
        ({keywords, codes}: { keywords: string, codes?: string }) => void;
    @Action('search/searchForResults') protected searchForResults!:
        ({keywords, codes}: { keywords: string, codes: string }) => void;
    @Mutation('search/setFilterData') protected setFilterData!: (filterData: FilterData) => void;

    protected get filterOptions() {
        return this.$store.getters[`search/filterOptions`];
    }

    protected get expandViaCpcs() {
        return this.$store.getters['search/expandViaCpcs'];
    }

    protected get searchCpcs() {
        return this.$store.getters[('search/searchCpcs')];
    }

    private get isNarrowKeywordValid() {
        if (!this.filterData.keywordInput) {
            return true;
        }
        return countWords(this.filterData.keywordInput.trim()) <= SearchConstants.MaxNarrowKeywords;
    }
    private get searchConstants() {
        return SearchConstants;
    }

    protected filterData: FilterData = {
        revenueRange: 0,
        years: 0,
        keywordInput: '',
        valuationCauses: [],
        withoutRevenueRecords: true,
        revenueTypes: [],
        brandCountries: [],
    };

    protected activeItems: string[] = [];
    protected isNarrowSearch = false;

    protected onDataChange = debounce(async () => {
        this.toggleLoading(true);
        if (this.sidebarMode === 'search') {
            await this.filterSearchResults(this.filterData);
        } else {
            await this.filterShoppingListRecords(this.filterData);
        }
        this.toggleLoading(false);
    }, 500);

    protected toggleLoading(value: boolean) {
        this.$emit('toggle-loading', value);
    }

    protected showError(error: string) {
        this.$message.error(error);
    }

    protected async onNarrowKeywordSearch() {
        const searchTerm = this.filterData.keywordInput;
        if (searchTerm && countWords(searchTerm.trim()) > SearchConstants.MaxNarrowKeywords) {
            this.showError(SearchConstants.SearchNarrowError);
            return;
        }
        this.isNarrowSearch = true;
        this.toggleLoading(true);
        const searchKeywords = this.$store.getters['search/searchKeywords'].split(/\s/);
        const searchObject: { keywords: string, codes?: string, narrowKeyword?: string } = {keywords: ''};
        searchObject.keywords = searchKeywords.filter((keyword: string) => keyword.trim() !== '').join(' ');
        searchObject.narrowKeyword = searchTerm ? searchTerm.trim() : '';
        if (this.searchCpcs) {
            searchObject.codes = this.searchCpcs;
        }
        await this.narrowSearchByKeyword(searchObject);
        await this.setFilterData(this.filterData);
        this.toggleLoading(false);
    }

    protected async onSearchViaCpc(cpcCode: string) {
        this.toggleLoading(true);
        await this.searchForResults({keywords: '', codes: cpcCode});
        this.toggleLoading(false);
    }

    protected formatValue(value: number | null) {
        if (!value) {
            return value;
        }
        return (value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ','));
    }

    protected mounted() {
        eventBus.$on(eventBusEvents.injectFilterData, (filterData: FilterData) => {
            this.filterData.revenueRange = filterData.revenueRange;
            this.filterData.years = filterData.years;
            this.filterData.keywordInput = filterData.keywordInput;
            this.filterData.valuationCauses = filterData.valuationCauses;
            this.filterData.withoutRevenueRecords = filterData.withoutRevenueRecords;
            this.filterData.revenueTypes = filterData.revenueTypes;
            this.filterData.brandCountries = filterData.brandCountries;
        });
    }

    @Watch('filterOptions', {immediate: true})
    protected onFilterOptionUpdate() {
        if (!this.filterOptions) {
            return;
        }
        if (!this.isNarrowSearch) {
            this.filterData.keywordInput = '';
        }
        this.filterData.revenueRange =
            [this.filterOptions.revenueRange.minValue, this.filterOptions.revenueRange.maxValue];
        this.filterData.years = [this.filterOptions.years.minValue, this.filterOptions.years.maxValue];
        this.filterData.brandCountries = Object.keys(this.filterOptions.brandCountries);
        this.filterData.revenueTypes = Object.keys(this.filterOptions.revenueTypes);
        this.filterData.valuationCauses = Object.keys(this.filterOptions.valuationCauses);
        this.filterData.withoutRevenueRecords = true;
        this.setFilterData(this.filterData);
        this.isNarrowSearch = false;
    }

    @Watch('filterOptions.brandCountries', {immediate: true})
    protected onCountriesValueChange() {
        if (this.filterOptions && Object.keys(this.filterOptions.brandCountries).length) {
            this.filterData.brandCountries = Object.keys(this.filterOptions.brandCountries);
        }
    }

    @Watch('numberOfReports', {immediate: true})
    protected onNumberOfReportsChange() {
        this.activeItems = this.numberOfReports < 2 ? [] : ['1', '2', '3', '4', '5', '6', '7'];
    }
}
